<template>
  <div class="mt16">
    <QS-h4-title title="司机警示金" />
    <el-row>
      <el-col :span="12">
        <el-table :data="driverWarningPayList">
          <el-table-column  prop="payItem" label="类型" >
            <template slot-scope="{row}">
              <span>
                {{row.payItem || '--'}}
              </span>
            </template>
          </el-table-column>
          <el-table-column  prop="totalAmount" label="应收金额（元）" >
            <template slot-scope="{row}">
              <span>
                {{row.totalAmount}}
              </span>
            </template>
          </el-table-column>

          <el-table-column  prop="receivableId" label="应收ID" >
            <template slot-scope="{row}">
              <span>
                {{row.receivableId || '--' }}
              </span>
            </template>
          </el-table-column>

          <el-table-column  prop="receivableState" label="收款状态" >
            <template slot-scope="{row}">
              <span>
                {{row.receivableStateName || '--' }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'driverWarningPay',
  props: ['driverWarningPayList'],
}
</script>
